

















































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "./Loading.vue";
import ShowMoreView from "../controls/ShowMoreView.vue";
import PointerMenu from "../general/PointerMenu.vue";
import SettingsMaterialItemDetails from "../settings/SettingsMaterialItemDetails.vue";

import UserJson from "../../shared/UserJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import UserPermissionJson from "../../shared/UserPermission";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateItemImageJson, validateItemImageJsonAdd } from "../../shared/ItemImageJson";

export default Vue.extend({
  name: "StaffInput",
  components: {
    Loading,
    ShowMoreView,
    PointerMenu,
    SettingsMaterialItemDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    data: Array as PropType<number[]>,
    editable: Boolean,
    customId: {
      default: "0",
    },
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      allUsers: null as UserJson[] | null,
      details: null as number[] | null,
      showStaffDetails: false as boolean,
      selectedStaffId: null as number | null,
      detailsMode: "read",
      staffIdToAdd: null as number | null,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    /*** START: details view ***/
    /* toggleMaterialItemDetails() {
      (this.$refs["showmore-materialItemDetails"] as any).toggleExpandable();
      this.showMaterialItemDetails = !this.showMaterialItemDetails;
      if (this.showMaterialItemDetails == false) {
        this.loadMaterialItems();
      }
    },

    openMaterialItemDetails(item: UserJson | null, mode: string) {
      if (item != null) {
        this.selectedMaterialItemId = item.ID;
      } else {
        this.selectedMaterialItemId = null;
      }

      this.detailsMode = mode;
      this.toggleMaterialItemDetails();
    }, */
    /*** END: details view ***/

    init() {
      this.details = this.data;

      this.loadAllUsers();
    },

    async loadAllUsers() {
      this.allUsers = null;

      if (this.restClient != null) {
        try {
          this.allUsers = await this.restClient.getUsers();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    addStaffId() {
      if (this.staffIdToAdd != null) {
        if (this.details == null) this.details = [];
        this.details.push(this.staffIdToAdd);

        this.staffIdToAdd = null;
      }
    },

    removeStaffId(index: number) {
      if (this.details != null) {
        this.details.splice(index, 1);

        if (this.details.length <= 0) this.details = null;
      }
    },

    //START set cached data

    //END set cached data

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    getStaffName(staffId: number): string | undefined {
      var staff = undefined;

      if (this.allUsers != null) {
        staff = this.allUsers.find((item: UserJson) => item.ID == staffId);
      }

      if (staff) {
        return staff.firstName + " " + staff.lastName;
      } else {
        return "Unbekannt";
      }
    },
  },

  watch: {
    details: {
      handler() {
        this.$emit("change", this.details);
      },
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    sortedUser: function (): { eventUser: UserJson[]; otherUser: UserJson[] } {
      var res: { eventUser: UserJson[]; otherUser: UserJson[] } = { eventUser: [], otherUser: [] };

      if (this.allUsers != null) {
        for (let user of this.allUsers) {
          if (user.userPermissions.find((i: UserPermissionJson) => i.type == "moduleEvents")) {
            res.eventUser.push(user);
          } else {
            res.otherUser.push(user);
          }
        }
      }

      return res;
    },
  },
});
